/**
 * api接口统一管理
 */
import {get, post} from './http'
import {getZ, postZ} from './http1'
// IM相关
// 判断使用新/旧IM系统
export const useNewIMApi = p => get('api/user/userImFromOrder', p);
//首页
export const apiDesktopIndex = p => get('api/desktop/index', p);
export const apiShowList = p => get('api/desktop/show/list', p);
export const apiPTotal = p => get('api/desktop/product/total', p);
export const apiDArticleList = p => get('api/desktop/article/list', p);
export const apiProductTop = p => get('api/desktop/product/top', p);
export const apiProductNew = p => get('api/desktop/product/new', p);
// export const apiNewTransaction = p => get('api/desktop/new/transaction', p);

//随机客服
export const apiCustomerRandom = p => get('api/customer/random', p);
//公告页面
export const apiArticleCategory = p => get('api/article/category', p);
export const apiArticleList = p => get('api/article/list', p);
//我要卖号 游戏账号
export const apiProductAdd = p => post('api/product/add', p);
//我要卖号 游戏金币
export const apiGoldAdd = p => post('api/gold/add', p);
//我要卖号 游戏金币
export const apiEquipAdd = p => post('api/equip/add', p);

//我要卖号 游戏账号 自主截图
export const apiUploadPicture = p => post('api/upload/picture', p);

//我要卖号 游戏装备 详情图片
export const apiUploadEquip = p => post('api/upload/equip', p);
//我要卖号 游戏装备 价值证明
export const apiUploadProve = p => post('api/upload/prove', p);

//全部游戏
export const apiGameList = p => get('api/game/list', p);
export const apiGameListForValuation = p => get('api/game/listForValuation', p);
export const apiGameClass = p => get('api/game/class', p);
//游戏筛选列表 属性查询
export const apiProductCategory = p => get('api/product/category', p); //游戏账号
export const apiGoldCategory = p => get('api/gold/category', p); //游戏金币
export const apiEquipCategory = p => get('api/equip/category', p); //游戏装备
//游戏筛选列表 二级属性查询
export const apiProductPcate = p => get('api/product/pcate', p); //游戏账号
export const apiProductMultilevel = p => get('api/product/multilevel', p); //盼之多层级搜索树(独立面板)
export const apiGoldAttr = p => get('api/gold/attr', p); //游戏金币
export const apiEquipAttr = p => get('api/equip/attr', p); //游戏金币
//游戏筛选列表 游戏账号列表
export const apiProductList = p => get('api/product/list', p);
export const apiEquipList = p => get('api/equip/list', p);
export const apiGoldList = p => get('api/gold/list', p);
//帐号详情
export const apiProductInfo = p => get('api/product/info', p);
//账号详情 · 多数据源归一 DetailDTO(自营/采集)
export const apiAccountDetailDto = p => get('api/product/info/dto', p);
export const apiUserProductInfo = p => get('api/user/product/info', p);
//账号详情 立即购买
export const apiProductBuyCheck = p => get('api/product/buy/now/check', p);
//立即购买-查询包赔信息 和 购买协议
export const apiProductBuy = p => get('api/product/buy/now', p);
//立即购买- 在线支付
export const apiConfirmPayment = p => post('api/product/confirm/payment', p);
// export const apiPaydetail = p => post('api/paydetail/pc', p); //获取二维码地址
export const apiPaydetail = p => post('api/paydetail/pc_web', p); //获取二维码地址
export const apiPayQuery = p => post('api/paydetail/query', p); //查询支付状态
export const apiOrderInfo = p => get('api/order/product/info', p); //查询订单信息

//装备详情
export const apiEquipInfo = p => get('api/equip/info', p);
//金币详情
export const apiGoldInfo = p => get('api/gold/info', p);
//账号详情 收藏
export const apiCollectSet = p => post('api/collect/set', p);
//装备详情 收藏
export const apiCollectEquip = p => post('api/collect/equip', p);
//金币详情 收藏
export const apiCollectGold = p => post('api/collect/gold', p);

//登录
export const apiLogin = p => post('api/login', p);
export const apiSmsLogin = p => post('api/smslogin', p);
export const apiLogout = p => post('api/out', p);
//注册
export const apiRegister = p => post('api/register', p);
//忘记密码
export const apiReset = p => post('api/reset', p);
//发送验证码
export const apiSmsSend = p => get('api/sms/send', p);
//换绑手机 验证验证码
export const apiSmsCheck = p => post('api/sms/check', p);
export const apiChangePhone = p => post('api/user/change/phone', p);
//黑号查询 & 客服账号验证 & 收款账户验证
export const apiBlackCheck = p => get('api/black/check', p);
export const apiCusVerify = p => get('api/customer/verify', p);
export const apiCusPayVerify = p => get('api/customer/payAccountCustomerVerify', p);
//官方支付账户配置列表
export const apiCusPayaccList = p => get('api/customer/payAccountCustomerList', p);

//个人中心 我的账号
export const apiuserInformation = p => get('api/user/information', p);
//用户基本信息
export const apiuserInfo = p => get('api/user/info', p);
//个人中心 个人信息
export const apiUserSave = p => post('api/user/save', p);
export const apiUserChangepwd = p => post('api/user/changepwd', p);
export const apiUserPaypwd = p => post('api/user/paypwd', p);
//个人中心 基本信息 头像上传
export const apiUploadPage = p => post('api/upload/page', p);
export const apiUploadAvatar = p => post('api/upload/avatar', p);
//个人中心 基本信息 实名认证
export const apiUserVerifed = p => post('api/user/verified', p);
export const apiUploadAuth = p => post('api/upload/auth', p);
//个人中心 基本信息 设置体现账户
export const apiUserSetAccount = p => post('api/user/setaccount', p);
export const apiBankName = p => get('api/bank/name', p);
//个人中心 我是卖家 账号列表
export const apiSellerAccountList = p => get('api/user/seller/account/list', p);
//个人中心 我是卖家 金币列表
export const apiSellerGoldList = p => get('api/gold/sell/list', p);
export const apirGoldInventory = p => post('api/gold/inventory', p); //修改库存
export const apirGoldOffshelf = p => post('api/gold/offshelf', p); //下架
export const apirGoldGore = p => post('api/gold/gore', p); //顶一顶
//个人中心 我是卖家 装备列表
export const apiSellerEquipList = p => get('api/equip/sell/list', p);
export const apiSellerEquipEditPrice = p => post('api/equip/edit/price', p); //改价
export const apirEquipInventory = p => post('api/equip/inventory', p); //修改库存
export const apirEquipOffshelf = p => post('api/equip/offshelf', p); //下架
export const apirEquipGore = p => post('api/equip/gore', p); //顶一顶
//个人中心 我是卖家 降价请求
export const apiSellerReduRequest = p => get('api/bargain/list/sale', p);
export const apiSellerReduRequestEquip = p => get('api/bargain/list/saleequip', p);

//我是卖家 修改价格
export const apiProductPrice = p => post('api/product/price', p);
//我是卖家 修改账号密码
export const apiProductEditinfo = p => get('api/product/editinfo', p);
export const apiProductAccount = p => post('api/product/account', p);
//顶一顶 下架 重选上架
export const apiProductGore = p => post('api/product/gore', p);
export const apiProductOff = p => post('api/product/offshelf', p);
export const apiProductOn = p => post('api/product/onshelf', p);
//个人中心 我是买家 账号订单
export const apiBuyAccountList = p => get('api/user/buy/account/list', p);
//个人中心 我是买家 账号订单 确认收货
export const apiManualReceipt = p => post('api/user/buy/order/manualReceipt', p);
export const apiBuyOrderList = p => post('api/user/buy/order/list', p);
export const apiBuyOrderDetail = p => post('/api/user/buy/order/detail', p);
//个人中心 我是买家 金币订单
export const apiBuyGoldList = p => get('api/order/list/gold', p);
//个人中心 我是买家 装备订单
export const apiBuyEquipList = p => get('api/order/list/equip', p);
//个人中心 我是买家 游戏账号 降价请求列表
export const apiBuyBargainList = p => get('api/bargain/list/buy', p);
//个人中心 我是买家 游戏装备 降价请求列表
export const apiBuyBargainListEquip = p => get('api/bargain/list/buyequip', p);
export const apiBuyBargainStatus = p => post('api/bargain/status', p);
export const apiBuyBargainEquipStatus = p => post('api/bargain/equipstatus', p);
//游戏账号 修改 发起降价请求
export const apiBargainEdit = p => post('api/bargain/edit', p);
//游戏账号 添加 发起降价请求
export const apiBargainAdd = p => post('api/bargain/add', p);
//游戏装备 添加 发起降价请求
export const apiBargainAddEquip = p => post('api/bargain/equip', p);
//发起降价请求点击量
export const apiBargainClcik = p => post('api/product/click', p);
//个人中心 我的收藏 游戏账号
export const apiCollectList = p => get('api/collect/list', p);
//个人中心 我的收藏 游戏装备
export const apiCollectListEquip = p => get('api/collect/listequip', p);
//个人中心 我的收藏 游戏金币
export const apiCollectListGold = p => get('api/collect/listgold', p);
//财务中心 充值
export const apiUserRecharge = p => post('api/user/recharge', p);
export const apiRechargeInfo = p => get('api/user/recharge/info', p);
//财务中心 提现
export const apiUserCashAdd = p => post('api/user/cash/add', p);
//财务中心 提现记录
export const apiUserCashList = p => get('api/user/cash/list', p);
export const apiUserCashStatus = p => post('api/user/cash/status', p);

//财务中心 收支明细
export const apiUserBillList = p => get('api/user/bill/list', p);
//个人中心 站内通知
export const apiStationList = p => get('api/station/list', p);
export const apiStationRead = p => post('api/station/read', p);
//账号交易 账号回收
export const apiRecyclingList = p => get('api/recycling/list', p);
export const apiRecyclingGameList = p => get('api/recycling/game/list', p);
export const apiRecyclingInfo = p => get('api/recycling/info', p);
//顶部 搜索
export const apiPSearchList = p => get('api/product/search/list', p);
//每日成交 全部
export const apiProductTotal = p => get('api/product/total', p);
//每日成交 昨日成交帐号详情
export const apiPDailyDetails = p => get('api/product/daily/details', p);
//每日成交 昨日成交装备详情
export const apiEquipyesterday = p => get('/api/order/list/equipyesterday', p);

//获取客服、售后、投诉链接
export const apiCustomerSys = p => get('api/setting/customer', p);
//导航菜单 下拉
export const apiNavPage = p => get('api/page/leftnav', p);
//顶部导航菜单
export const apiTopNav = p => get('api/desktop/topnav', p);
//单页面数据
export const apiPageInfo = p => get('api/page/info', p);
//客服服务中心
export const apiCusCateGory = p => get('api/customer/category', p);
export const apiCusList = p => get('api/customer/list', p);
export const apiGameCusSer = p => get('api/game/customer', p);
//游戏详情（含手续费率）
export const apiGameInfo = p => get('api/game/info', p);
//系统配置信息
export const apiSystem = p => get('api/setting/system', p);
//求降价状态更改
export const apiPremiumEdit = p => post('api/product/premium/status', p);

//昨天成交
export const apiYesterdayDeal = p => get('api/product/yesterday/deal', p);

//53保存用户访问的客服链接
export const apiUserAccessLink = p => post('api/user/access/link', p);


//websocket
export const apiBind = p => post('im/bind', p);
//房间列表
export const apiRoomList = p => get('im/room/list', p);
//买卖双发加入房间
export const apiRoomJoin = p => post('im/room/join', p);
//进入已绑定的房间
export const apiRoomEnter = p => post('im/room/enter', p);
//发消息
export const apiMsgSend = p => post('im/message/send', p);
//获取历史消息
export const apiMsgHistory = p => get('im/message/history', p);
//私聊
export const apiRoomCreate = p => post('im/room/create', p);
//退出房间
export const apiRoomKill = p => post('im/room/kill', p);

//根据用户输入的登录账号查询  在本平台交易次数
export const apiProductTransactions = p => get('api/product/transactions', p);

// 添加估价信息
export const apiValuation = p => post('api/assess/product/add', p);
// 估价信息详情
export const apiValuationDetail = p => get('api/assess/product/info', p);


//全部游戏列表 最近浏览
export const apiHistoryAdd = p => post('api/history/game/add', p);
export const apiHistoryList = p => get('api/history/game/list', p);
export const apiHistoryDel = p => post('api/history/game/del', p);

//商品浏览记录
export const apiHistoryProductAdd = p => post('api/history/product/add', p);
export const apiHistoryProductList = p => get('api/history/product/list', p);
//商品客服咨询记录
export const apiHistoryCusAdd = p => post('api/history/customer/add', p);
export const apiHistoryCusDel = p => post('api/history/customer/del', p);
export const apiHistoryCusList = p => get('api/history/customer/list', p);

//招聘列表
export const apiRecruitList = p => get('api/recruit/list', p);
export const apiRecruitInfo = p => get('api/recruit/Info', p);

//卖家合同
export const apiSellContract = (u,p) => u===1?post('api/contract/seller',p):postZ('app/contract/seller', p);
//卖家合同上传身份证
export const apiSellCard = (u,p) => u===1?post('api/upload/newCard', p):postZ('app/upload/newCard', p);
export const apiExpressSheet = (u,p) => u===1?post('api/upload/Card', p):postZ('app/upload/Card', p);
export const appUploadAuth = (u,p) => u===1?post('api/upload/auth', p):postZ('app/upload/auth', p);
export const appUploadAuthCardBehind = (u,p) => u===1?post('api/upload/authCardBehind', p):postZ('app/upload/authCardBehind', p);
// 合同实名认证
export const appAliyunAuth = (u,p) => u===1?post('api/upload/aliyunAuth', p):postZ('app/upload/aliyunAuth', p);
//买家合同
export const apiBuyerContract = (u,p) => u===1?post('api/contract/buyer', p):postZ('app/contract/buyer', p);
// 获取用户合同信息
export const apiuserContract = (u,p) => u===1?post('api/contract/userContract', p):postZ('app/contract/userContract', p);
// 获取合同订单号
export const apiContractDetails = (u,p) => u===1?post('api/contract/contractDetails', p):postZ('app/contract/contractDetails', p);
// 包赔核对详情
export const apibenefitCheckDetails = (u,p) => get(u===1?'/api/contract/benefitCheck/details':'/app/contract/benefitCheck/details', p);
// 获取用户合同详情
export const apiContractUserDetails = (u,p) => get(u===1?'/api/contract/user/details':'/app/contract/user/details', p);
// 包赔核对更新
export const apibenefitCheckUpdate = (u,p) => post(u===1?'/api/contract/benefitCheck/update':'/app/contract/benefitCheck/update', p);

// 包赔
export const apiCompensations = (u,p) => post(u===1?'api/contract/compensations':'app/contract/compensations', p);
// 问卷调查判断
export const apiGetstatus = p => post('api/survey/getstatus', p);
// 问卷调查获取问卷信息
export const apiGetsurvey = p => post('api/survey/getsurvey', p);
// 问卷调查提交
export const apiSurveyAdd = p => post('api/survey/add', p);
// 调研问卷中奖名单
export const apiGetwinner = p => post('api/survey/getwinner', p);

// 个人中心 合同信息列表
export const apiContractList = p => get('api/user/contract/list', p);
// 个人中心 合同信息-签署合同
export const apiContractSigned = p => post('api/user/contract/signed', p);
// 个人中心 合同信息-法大大实名认证
export const apiContractVerify = p => post('api/user/contract/fdd/personVerify', p);
// 个人中心 合同信息-合同下载
export const apiDownloadContract = p => get('api/user/contract/fdd/downLoadContract', p);
// 号商广告位
export const apiMerchantProduct = p => get('api/product/merchant/list', p);
// 帮助中心
export const apiHelpCenter = p => get('api/article/help', p);
// 帮助中心 全部问题
export const apiHelpAll = p => get('api/article/all', p);
// 帮助中心详情
export const apiHelpDetail = p => get('api/article/list', p);
// 帮助中心搜索
export const apiHelpSearch = p => post('api/article/search', p);
// 发布的账号审核失败 删除
export const apiProductDel = p => post('api/product/del', p);

//我是卖家求降价列表 批量删除
export const apiBargainSaleDel = p => post('api/bargain/sale/del', p);
//我是买家发起降价列表 批量删除
export const apiBargainBuyDel = p => post('api/bargain/bargain/del', p);
// 个人中心 合同信息-查看合同
export const apiViewContract = p => get('api/user/contract/fdd/viewContract', p);
// 个人中心 站内通知-一键已读
export const apiReadAll = p => post('api/readall', p);
// 自抽号下单页信息
export const apiSelfChooseInfo = p => post('/api/self/choose/info', p);

// 搜索推荐
export const searchParticiple = p => get('api/search/participle', p);
// 客服中心 客服搜索
export const apiCustomerSearch = p => post('api/customer/center/search', p);
// 卖号提交用户来源
export const apiuserGameSource = p => post('api/product/userGameSource', p);

//聊天室拓展信息
export const apiRoomextInfo = p => get('/im/api/roomext/info', p);
//聊天室扩展信息新增
export const apiRoomextAdd = p => post('/im/api/roomext/add', p);
//聊天室扩展信息修改
export const apiRoomextEdit = p => post('/im/api/roomext/edit', p);
//聊天室游戏属性分类
export const imGameCategory = p => get('/im/api/game/category', p);
//聊天室游戏子属性分类
export const imGamePcate = p => get('/im/api/game/pcate', p);
//访问统计
export const apiStatisticsAdd = p => get('api/statistics/add', p);
// 合同配置详情文案
export const apigetcontractset = p => post('api/conf/getcontractset', p);
// 获取oss上传配置
export const apiGetOssConfig = p => get('/api/tempAuth', p);
// 聊天室 新增商品咨询记录
export const apiChatProductAdd = p => post('/im/chatroom/product/add', p);
// 聊天室 获取跟房间绑定订单列表
export const apiChatOrderList = p => get('/im/chatroom/order/list', p);
// 聊天室 获取私聊房间正在咨询的商品
export const apiChatProductConsult = p => get('/im/chatroom/product/consult', p);
// 聊天室 获取票据列表
export const apiInvoiceList = p => get('/im/chatroom/finance/invoice/list', p);
// 聊天室 用户点击已付款或取消付款
export const apiChatOrderPaidNotice= p => post('/im/chatroom/order/paid/notice', p);
// 聊天室 用户申请退款
export const apiChatOrderRefundPay= p => post('/im/chatroom/order/refund/payee/account/store', p);
// 聊天室 收集用户收款信息
export const apiChatOrderPaymenty= p => post('/im/chatroom/order/payment/payee/account/store', p);
// 聊天室 用户取消申请退款
export const apiChatOrdercancelstore= p => post('im/chatroom/order/refund/payee/account/cancelstore', p);
// 聊天室 获取订单详情
export const apiOrderDetail = p => get('/im/chatroom/order/detail', p);

// 聊天室 用户支付
export const apiPayPc= p => post('/api/pay/pc', p);
// 聊天室 查询是否支付成功
export const apiPayPcQuery= p => post('/api/pay/query', p);

// 聊天室获取客服信息
export const apihurrylist = p => post('/api/customer/hurrylist', p);
// 获取客服二维码信息
export const apiGetCustomerQrcodeInfo = p => get('api/customer/get_customer_qrcode_info', p);
//  获取客服二维码列表
export const apiGetCustomerQrcodeList = p => get('api/customer/get_customer_qrcode_list', p);
//获取投诉建议配置
export const getComplainsetting = p =>
  get("/api/desktop/complainsetting/details", p);

// 获取抢购组是否开启
export const apigetSnapUp = p => get('/api/getSnapUp', p);

// 留言板功能
export const leaveMsgApi = p => postZ('api/customer/messageAdd', p);



//个人中心 我是卖家 收款列表
export const apiUserAccountList = p => get('/api/userAccount/list', p);
export const apiUserAccountLending = p => post('/api/userAccount/lending', p); //申请放款
export const apiUserAccountAdd = p => post('/api/userAccount/add', p); //添加
export const apiUserAccountEdit = p => post('/api/userAccount/edit', p); //修改
export const apiUserAccountDel = p => post('/api/userAccount/delete', p); //删除
export const apiUserAccountLendAcc = p => get('/api/userAccount/lendAccount', p); //查看已申请的放款信息

// 个人中心 我是买家 收集退款信息
export const apicreateRefund = p => post('/api/user/buy/order/createRefund', p); //线下订单退款
export const apiOrderRefund = p => post('/api/paydetail/order_refund', p); //线上订单退款
export const apiOrderCancel = p => post('/api/paydetail/order_cancel', p); //订单超时状态变更

//站内信支付消息 获取房间号
export const apiStationPay = p => post('/api/station/payclick', p);

// 买家咨询卖家获取房间id
export const apiConsult = p => post('/api/consult/consult', p);
// 买家咨询卖家获取房间商品信息
export const apiGetroomdetailbyroomid = p => post('/im/chatroom/getroomdetailbyroomid', p);
// 站内信 买家咨询的卖家点击站内信
export const apiconsultclick = p => post('/api/station/consultclick', p);
// 买家咨询卖家获取房间订单状态
export const apiOrderList = p => get('/api/userAccount/orderList', p);
// seo需求 百度统计
export const downloadCounter = p => get('/api/desktop/download/counter', p);

// 详情页求降价结果
export const apiMyBargain = p => get('/api/bargain/my_bargain', p);
// 个人中心 买家同意还价
export const apiBuyuserAgreeBargain = p => post('/api/bargain/buyuser_agree_bargain', p);

// 发布商品获取服务信息
export const apiGetServicesInfo = p => get('/api/game/getServicesInfo', p);
// 服务订单列表
export const apiGetServicesList = p => get('/api/serve/list', p);
// 服务订单详情
export const apiServeInfo = p => get('/api/serve/info', p);
// 诚心卖支付
export const apiPaypayserve = p => post('/api/payserve/pc_web', p);
// 新增服务订单
export const apiServeAdd = p => post('/api/serve/add', p);
// 查询诚心卖支付是否成功
export const apiServeQuery = p => post('/api/payserve/query', p);
// 诚心卖-用户申请退款
export const apiServeRefund = p => post('/api/payserve/order_refund', p);

// 连连支付-账号微信扫码支付
export const apiLianlianWxpay = p => post('/api/lianlian/wxpay_pc', p);
// 连连支付-账号支付宝扫码支付
export const apiLianlianAlipay = p => post('/api/lianlian/alipay_pc', p);
// 连连支付-诚心卖微信扫码支付
export const apiLianlianserveWxpay = p => post('/api/lianlianserve/wxpay_pc', p);
// 连连支付-诚心卖支付宝扫码支付
export const apiLianlianserveAlipay = p => post('/api/lianlianserve/alipay_pc', p);
// 连连支付-查询账号是否支付成功
export const apiLianlianQuery = p => post('/api/lianlian/query', p);
// 连连支付-查询诚心卖是否支付成功
export const apiLianlianserveQuery = p => post('/api/lianlianserve/query', p);
// 查询使用连连支付 || 官方支付宝支付
export const apiPaySwitch = p => post('/api/paydetail/payment_method', p);

// 收款账户列表
export const accountList = () => get('/api/userAccounts/list');
// 添加收款账户
export const addAccount = p => post('/api/userAccounts/add', p);
// 编辑收款账户
export const editAccount = p => post('/api/userAccounts/edit', p);
// 银行编码列表
export const bankList = () => get('/api/userAccounts/bankCodeList');

// 获取卖家资料基础信息
export const apiContractSellerInformation = p => get('/im/chatroom/contract/automation/sellerInformation/baseInfo', p);
// 卖家资料基础信息保存
export const apiContractSellerInformationAdd = p => post('/im/chatroom/contract/automation/sellerInformation/add', p);
// 合同自动化中间页获取签署链接
export const apiContractSellerInformationLink = p => post('/im/chatroom/contract/automation/link', p);
// 合同自动化实名认证（无验证码）
export const apiContractsellerInfoVerified = (u,p) => post(u===1?'/api/user/sellerInfoVerified':'/app/user/sellerInfoVerified', p);
// 优惠券详情
export const couponDetail = p => post('/api/coupon/detail', p);
// 优惠券领取
export const couponReceive = p => post('/api/coupon/receive', p);
// 优惠券列表
export const couponList = p => get('/api/user/coupon/list', p);
// cj获取注册总数
export const registerStatics = p => get("/api/user/registerStatics", p);
// cj获取抽奖码总数
export const getCodeCount = p => get("/api/cj_activity/getCodeCount", p);
// cj获取时间配置
export const getSetting = p => get("/api/cj_activity/getSetting", p);
// cj获取最新中奖码
export const getCode = p => post("/api/cj_activity/getPrizeCode", p);
// cj获取倒计时配置
export const getCountDown = p => get("/api/cj_activity/getCountDown", p);

//游戏卖号界面提示
export const apiSalePopupControll = p => get("/api/game/salePopupControll", p);

// 合同二期-获取买家资料基础信息
export const apiContractBuyerInformation = p => get('/im/chatroom/contract/automation/buyerInformation/baseInfo', p);
// 合同二期-我的签约人列表
export const signatoryList = p => get('/im/chatroom/contract/automation/signatory/list', p);
// 合同二期-我的签约人详情
export const signatoryDetails = p => get('/im/chatroom/contract/automation/signatory/details', p);
// 合同二期-我的签约人删除
export const signatoryDel = p => post('/im/chatroom/contract/automation/signatory/delete', p);
// 合同二期-我的签约人添加
export const signatoryAdd = p => post('/im/chatroom/contract/automation/signatory/add', p);
// 合同二期-我的签约人修改
export const signatoryEdit = p => post('/im/chatroom/contract/automation/signatory/update', p);
// 合同二期-买家资料提交
export const apiBuyerInformationAdd = p => post('/im/chatroom/contract/automation/buyerInformation/add', p);
// 合同二期实名认证（无验证码）
export const apiContractuserSignVerified = (u,p) => post(u===1?'/api/user/userSignVerified':'/app/user/userSignVerified', p);

// 买家发起求降价诚意金订单
export const earnestCreate = p => post('/api/earnest/create', p);
//获取提交诚意金订单配置
export const createPrepare = p => get('/api/earnest/buy/createPrepare', p);
// 买家提交议价
export const earnestBargin = p => post('/api/earnest/buy/bargain', p);
// 买家同意卖家出价
export const earnestAgree = p => post('/api/earnest/buy/agree', p);
// 买家放弃
export const earnestGiveUp = p => post('/api/earnest/buy/giveUp', p);
// 买家确定底价购买
export const earnestFloor = p => post('/api/earnest/buy/bargainReservePrice', p);
// 尾款支付跳转钱预备接口
export const payPrepare = p => get('/api/earnest/buy/productPaymentPrepare', p);
// 买家申请验号
export const applyVerify = p => post('/api/earnest/buy/applyVerify', p);
// 买家验号确认
export const verifyPass = p => post('/api/earnest/buy/verifyPass', p);
// 买家验号放弃
export const verifyGiveUp = p => post('/api/earnest/buy/verifyGiveUp', p);
// 买家催一催
export const buyerUrge = p => post('/api/earnest/buy/urge', p);
// 买家查看底价
export const checkFloorPrice = p => post('/api/earnest/buy/getProductReservePrice', p);
// 获取当前账号的底价信息
export const currentPrice = p => post('/api/earnest/buy/productReservePriceConfig', p);
// 验号报告
export const verifyReport = p => post('/api/earnest/buy/verifyReport', p);
// 买家诚意买订单列表
export const earnestList = p => get('/api/earnest/buy/orderList', p);
// 买家诚意买订单详情
export const earnestDetail = p => get('/api/earnest/buy/orderDetail', p);
// 诚意买-pc支付
export const officialPay = p => post('/api/payearnest/pc_web', p);
// 诚意买-pc 查询是否支付成功
export const officialQuery = p => post('/api/payearnest/query', p);
// 诚意买--连连支付 支付宝
export const aliLianLianEarnestPay = p => post('/api/lianlianearnest/alipay_pc', p);
// 诚意买--连连支付 微信
export const wxLianLianEarnestPay = p => post('/api/lianlianearnest/wxpay_pc', p);
// 诚意买--连连支付   查询是否支付成功
export const earnestPayQuery = p => post('/api/lianlianearnest/query', p);
// 诚意买卖家-求降价订单列表
export const apiEarnestOrderList = p => get('/api/earnest_order/list', p);
// 诚意买卖家-求降价订单终止
export const apiEarnestOrderOff = p => post('/api/earnest_order/off', p);
// 诚意买卖家-求降价订单同意
export const apiEarnestOrderAgree = p => post('/api/earnest_order/agree', p);
// 诚意买卖家-求降价订单拒绝
export const apiEarnestOrderRefuse = p => post('/api/earnest_order/refuse', p);
// 诚意买卖家-求降价订单还价
export const apiEarnestOrderDicker = p => post('/api/earnest_order/dicker', p);
// 诚意买卖家-求降价订单详情
export const apiEarnestOrderDetail = p => get('/api/earnest_order/detail', p);
// 卖家个人中心求降价设置
export const apiEarnestOrderSaveBargain = p => post('/api/earnest_order/saveBargain', p);
// 诚意买卖家-催促
export const apiEarnestOrderUrge = p => get('/api/earnest_order/urge', p);
// 诚意买卖家-发送账密
export const apiEarnestOrderSendAccount = p => get('/api/earnest_order/sendAccount', p);
// 求降价状态接口
export const bargianStatus = p => get('/api/earnest/buy/createCheck', p);
// 卖家个人中心下架校验是否有待支付单
export const apiProductCheckWaitingPay = p => post('/api/product/checkWaitingPay', p);
// 诚意金支付跳转前预备接口
export const paymentPrepare = p => get('/api/earnest/buy/paymentPrepare', p);
// 诚意买提醒买家
export const closeRemind = p => get('/api/earnest_order/closeRemind', p);
// 诚意金支付跳转前预备接口
export const delOldBargin = p => post('/api/bargain/delHandlingBargain', p);
// 生成估价图片
export const apicreateAssessImage = p => get('/api/assess/product/getAssessImage', p);
// 商品二次编辑校验
export const reeditingCheck = p => post('/api/product/reeditingCheck', p);

// 新获取商品信息接口
export const getProductInfoApi = p => get('/api/product/getProductInfo', p);

// 商品二次编辑提交
export const reeditingProductApi = p => post('/api/product/reeditingProduct', p);

// 待跟进商品编辑提交
export const followingEditApi = p => post('/api/product/followingEdit', p);

// 上架原账号
export const onShelfOriginApi = p => post('/api/product/onShelfOrigin', p);
// 申请售后获取房间
export const afterSaleIntoRoomApi = p => post('/api/after_sale/intoRoom', p);
// 售后详情
export const afterSaleDetailApi = p => get('/api/after_sale/detail', p);

// 获取虚拟奖品列表
export const couponPrizeListApi = p => get('/api/festivalActivity/couponPrizeList', p);
// 获取实物奖品列表
export const underPrizeListApi = p => get('/api/festivalActivity/underPrizeList', p);
// 标记钥匙已展示
export const toMarkLotteryKey = p => get('/api/festivalActivity/toMarkLotteryKey', p);
// 获取需要展示的钥匙
export const getLotteryKeyPop = p => get('/api/festivalActivity/getLotteryKeyPop', p);

// 获取跳转分组标识(立即购买/咨询客服)
export const getAllotGroupCode = p => post('/api/customercare/get_allot_groupCode', p);
// 获取站内信未读
export const msgTips = p => get('/api/station/msgTips', p);
